export type PopupRows = Array<[label: string, value: unknown]>;

export function renderRows(rows: PopupRows): string {
  return rows
    .filter(([, v]) => v != null && String(v) !== "")
    .map(
      ([k, v]) =>
        `<tr class="nwa-popover__row"><th class="nwa-popover__th">${k}</th><td class="nwa-popover__td">${String(
          v,
        )}</td></tr>`,
    )
    .join("");
}

export function renderPopup(options: {
  title: string;
  severity?: string | null; // optional für NWA
  rows: PopupRows;
  theme?: "nwa" | "thunderstorm";
}): string {
  const theme = options.theme ?? "nwa";
  const severityAttr = options.severity ? ` data-severity="${options.severity}"` : "";
  const severityDot = options.severity ? `<span class="nwa-popover__severity-dot"${severityAttr}></span>` : "";

  return `
    <div class="nwa-popover ${theme === "thunderstorm" ? "nwa-popover--thunderstorm" : ""}">
      <div class="nwa-popover__header">
        <span class="nwa-popover__title">${options.title}</span>
        ${severityDot}
      </div>
      <table class="nwa-popover__table">
        ${renderRows(options.rows)}
      </table>
    </div>`;
}
